import "shared/lib/extensions/array.extension";
import "shared/lib/extensions/date.extension";
import "shared/lib/extensions/set.extension";
import "shared/lib/extensions/string.extension";
import "shared/styles/app.scss";

export { Application as default } from "application";
